import { differenceInDays, format, parseISO } from "date-fns";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface NextTestProps {
  date: string;
}

export const NextTest = ({ date }: NextTestProps) => {
  const { t } = useTranslation();
  const parsed = parseISO(date);
  const formatted = format(parsed, t("patient_detail.date_format"));
  const days = differenceInDays(date, new Date());

  return (
    <div className="rounded-2xl bg-gradient-to-b from-surface-container-high to-surface-container-low p-5 text-neutral-900 shadow-sm dark:from-surface-container-high-dark dark:to-surface-container-low-dark dark:text-white">
      <div className="grid-row-3 grid items-center justify-between gap-4">
        <p className="text-xl text-neutral-900 dark:text-white">
          {t("patient_detail.next_test")}
        </p>
        <p className="text-neutral-900 dark:text-white">{formatted}</p>
        <div
          className={twMerge(
            "flex flex-row items-center rounded-2xl border px-4 py-2",
            days > 60 && "border-complementary-green",
            days <= 60 && days > 30 && "border-complementary-orange",
            days < 30 && "border-complementary-red",
          )}
        >
          <p className="mr-2 text-lg text-neutral-900 dark:text-white">
            {days}
          </p>
          <p className="text-neutral-900 dark:text-white">
            {t("patient_detail.days_remaining")}
          </p>
        </div>
      </div>
    </div>
  );
};
